import { jsx as e, jsxs as c, Fragment as y } from "react/jsx-runtime";
import { useRef as l, useCallback as b, useEffect as x } from "react";
import '../../assets/AdBlock.css';const N = {
  "ad-anchor": "_ad-anchor_3lwu0_8",
  "ad-copy__link": "_ad-copy__link_3lwu0_19",
  "ad-image": "_ad-image_3lwu0_23",
  "ad-image__text": "_ad-image__text_3lwu0_50",
  "ad-copy": "_ad-copy_3lwu0_19",
  "ad-image--animate": "_ad-image--animate_3lwu0_61",
  "promo-slide-in-left": "_promo-slide-in-left_3lwu0_1",
  "ad-copy--animate": "_ad-copy--animate_3lwu0_68",
  "promo-slide-in-right": "_promo-slide-in-right_3lwu0_1",
  "ad-copy__header": "_ad-copy__header_3lwu0_76",
  "ad-copy__description": "_ad-copy__description_3lwu0_81"
}, w = {
  "ad-anchor": "_ad-anchor_iji3s_17",
  "ad-copy__link": "_ad-copy__link_iji3s_28",
  "ad-image": "_ad-image_iji3s_42",
  "ad-image__text": "_ad-image__text_iji3s_59",
  "ad-copy": "_ad-copy_iji3s_28",
  "ad-image--animate": "_ad-image--animate_iji3s_78",
  "promo-slide-in-left": "_promo-slide-in-left_iji3s_1",
  "ad-copy--animate": "_ad-copy--animate_iji3s_85",
  "promo-slide-in-right": "_promo-slide-in-right_iji3s_1",
  "ad-copy__header": "_ad-copy__header_iji3s_93",
  "ad-copy__description": "_ad-copy__description_iji3s_105",
  "ad-copy__link-text": "_ad-copy__link-text_iji3s_106"
}, j = {
  "ad-anchor": "_ad-anchor_1k4cf_26",
  "ad-copy__link": "_ad-copy__link_1k4cf_37",
  "background-container": "_background-container_1k4cf_41",
  "ad-copy": "_ad-copy_1k4cf_37",
  "ad-copy__header": "_ad-copy__header_1k4cf_57",
  "ad-copy__description": "_ad-copy__description_1k4cf_67",
  "cta-container": "_cta-container_1k4cf_78",
  "cta-container__link": "_cta-container__link_1k4cf_89",
  "ad-image": "_ad-image_1k4cf_108",
  "ad-image__text": "_ad-image__text_1k4cf_127",
  "ad-image-mobile": "_ad-image-mobile_1k4cf_137",
  "ad-image--animate": "_ad-image--animate_1k4cf_240",
  "promo-slide-in-right": "_promo-slide-in-right_1k4cf_1",
  "ad-copy--animate": "_ad-copy--animate_1k4cf_247",
  "promo-slide-in-left": "_promo-slide-in-left_1k4cf_1",
  "ad-cta--animate": "_ad-cta--animate_1k4cf_254",
  "ad-mobile-disclaimer--animate": "_ad-mobile-disclaimer--animate_1k4cf_268"
}, v = {
  "ad-anchor": "_ad-anchor_15im4_1",
  "cta-container__link": "_cta-container__link_15im4_11"
};
function L({ image: _, ad: i, theme: n = "default" }) {
  const a = (/* @__PURE__ */ new Map([
    ["default", N],
    ["round2", w],
    ["tablotv", j],
    ["imageonly", v]
  ])).get(n), g = i.campaign === "" ? "" : `?utm_campaign=${i.campaign}&utm_source=${i.source}&utm_medium=${i.medium}&utm_content=${i.content}`, s = l(), t = l(), d = l(), m = l(), p = l(), f = l(), o = `${i.href}${g}`, h = b((r, k) => {
    r.forEach((u) => {
      u.isIntersecting && (n === "tablotv" && (d.current.classList.add(`${a["ad-cta--animate"]}`), f.current.classList.add(`${a["ad-mobile-disclaimer--animate"]}`)), s.current.classList.add(`${a["ad-copy--animate"]}`), t.current.classList.add(`${a["ad-image--animate"]}`), k.unobserve(t.current));
    });
  }, [a]);
  return x(() => {
    if (n !== "imageonly") {
      const r = new IntersectionObserver(h, {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      });
      return r.observe(t.current), () => {
        r.disconnect();
      };
    }
  }, [n, h]), /* @__PURE__ */ e(
    "ad-block",
    {
      class: `${a["ad-anchor"]}`,
      onClick: (r) => {
        (r.target === d.current || r.target === m.current || r.target === p.current) && r.preventDefault(), window.open(d.current, "_blank");
      },
      children: n === "imageonly" ? /* @__PURE__ */ e("a", { className: a["cta-container__link"], href: o, target: "_blank", rel: "noreferrer", ref: d, children: /* @__PURE__ */ e("span", { className: "sr-only", children: _.text }) }) : n === "tablotv" ? /* @__PURE__ */ c("div", { className: a["background-container"], children: [
        /* @__PURE__ */ c("div", { className: a["ad-copy"], ref: s, children: [
          /* @__PURE__ */ e("h4", { className: a["ad-copy__header"], children: i.header }),
          /* @__PURE__ */ e("div", { className: a["ad-image-mobile"], ref: t, children: /* @__PURE__ */ e("ad-image", { children: /* @__PURE__ */ e("a", { href: o, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ e("img", { src: _.mobile, alt: _.altText, ref: p }) }) }) }),
          /* @__PURE__ */ e("p", { className: a["ad-copy__description"], children: i.description })
        ] }),
        /* @__PURE__ */ c("div", { className: a["cta-container"], children: [
          /* @__PURE__ */ e("a", { className: a["cta-container__link"], href: o, target: "_blank", rel: "noreferrer", ref: d, children: i.linkText }),
          /* @__PURE__ */ e("span", { className: a["ad-image__text"], ref: f, children: _.text })
        ] }),
        /* @__PURE__ */ c("div", { className: a["ad-image"], ref: t, children: [
          /* @__PURE__ */ e("ad-image", { children: /* @__PURE__ */ e("a", { href: o, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ e("img", { src: _.url, alt: _.altText, ref: m }) }) }),
          /* @__PURE__ */ e("span", { className: a["ad-image__text"], children: _.text })
        ] })
      ] }) : /* @__PURE__ */ c(y, { children: [
        /* @__PURE__ */ c("div", { className: a["ad-image"], ref: t, children: [
          /* @__PURE__ */ e("span", { className: a["ad-image__text"], children: _.text }),
          /* @__PURE__ */ e("ad-image", { children: /* @__PURE__ */ e("a", { href: o, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ e("img", { src: _.url, alt: _.altText, ref: m }) }) })
        ] }),
        /* @__PURE__ */ c("div", { className: a["ad-copy"], ref: s, children: [
          /* @__PURE__ */ e("h4", { className: a["ad-copy__header"], children: i.header }),
          /* @__PURE__ */ e("p", { className: a["ad-copy__description"], children: i.description }),
          /* @__PURE__ */ e("a", { className: a["ad-copy__link"], href: o, target: "_blank", rel: "noreferrer", ref: d, children: i.linkText })
        ] })
      ] })
    }
  );
}
export {
  L as AdBlock,
  L as default
};
